import { useContext } from 'react';
import styled from '@emotion/styled';

import { LegacyContext } from '../context/global-context';

import { Label } from './Label';
import { Overflow } from './Overflow';

const List = styled.ul<{ slots: number }>`
  display: flex;
  list-style-type: none;
  margin: 0;
  padding: 0;
`;

const Item = styled.li<{ size: number }>`
  margin: 0;
  padding: 0;

  // NOTE: not from DS as we need to make it looking great :)
  margin-left: -${({ size }) => size / 3}px;
  &:first-of-type {
    margin-left: 0;
  }
`;

const itemSizeInPixels = {
  m: 16,
  l: 24,
} as const;

interface AppliedLabelsProps {
  className?: string;
  labels: Array<{
    id: string;
    iconName: React.ComponentProps<typeof Label>['iconName'];
    name: React.ComponentProps<typeof Label>['name'];
  }>;
  size: 'm' | 'l';
  slotsNumber: number;
}

export function AppliedLabels({
  className,
  labels,
  size,
  slotsNumber,
}: AppliedLabelsProps): JSX.Element {
  const { calculateOverflow = () => [[], 0] } = useContext(LegacyContext);
  const [visibleLabels, overflowCount] = calculateOverflow(labels, slotsNumber);

  return (
    <List className={className} slots={slotsNumber}>
      {visibleLabels.map(({ id, ...label }) => (
        <Item key={id} size={itemSizeInPixels[size]}>
          <Label {...label} size={size} />
        </Item>
      ))}
      {overflowCount > 0 ? (
        <Item key="overflow" size={itemSizeInPixels[size]}>
          <Overflow number={overflowCount} size={size} />
        </Item>
      ) : null}
    </List>
  );
}
